import { AbstractRepository } from '../AbstractRepository';
import { HandledTenant } from './types';
import ShellLocalStorageDAOImpl from '../../dao/ShellLocalStorageDAOImpl';

export class HandledTenantsRepository extends AbstractRepository<
  HandledTenant[]
> {
  public static PREFIX_KEY = 'jshellHandledTenants';

  constructor(shellLocalStorageDAOImpl: ShellLocalStorageDAOImpl) {
    super({
      shellDAO: shellLocalStorageDAOImpl,
      prefixKey: HandledTenantsRepository.PREFIX_KEY
    });
  }

  saveAll(): HandledTenant[][] {
    console.debug('Not supported in HandledTenantRepository.');
    throw new Error('Method not implemented.');
  }

  findAll(): HandledTenant[][] {
    console.debug('Not supported in HandledTenantRepository.');
    throw new Error('Method not implemented.');
  }
}
